exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js?modules&importLoaders=1!../../../node_modules/postcss-loader/index.js!../../styles/mixins.css"), undefined);

// module
exports.push([module.id, ".CsZNCd4enmQQF8gl7_jxs{display:block}", ""]);

// exports
exports.locals = {
	"popover": "CsZNCd4enmQQF8gl7_jxs",
	"error": "_3_OFdfC8vCDtdcFXMQhMNp " + require("-!../../../node_modules/css-loader/index.js?modules&importLoaders=1!../../../node_modules/postcss-loader/index.js!../../styles/mixins.css").locals["error"] + ""
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1!./~/postcss-loader!./src/components/error/error.css
// module id = 283
// module chunks = 0 1 2